webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(12)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(24),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_scrollto__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_material__);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_scrollto___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_material___default.a.MdCore);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_material___default.a.MdIcon);

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Ahead__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Ahead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Ahead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Presentation__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Presentation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Presentation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Categorie__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Categorie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Categorie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Navigation__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vanilla_tilt__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vanilla_tilt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vanilla_tilt__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: { ahead: __WEBPACK_IMPORTED_MODULE_0__components_Ahead___default.a, presentation: __WEBPACK_IMPORTED_MODULE_1__components_Presentation___default.a, categories: __WEBPACK_IMPORTED_MODULE_2__components_Categorie___default.a, navigation: __WEBPACK_IMPORTED_MODULE_3__components_Navigation___default.a, tilt: __WEBPACK_IMPORTED_MODULE_4_vanilla_tilt___default.a },
  data: function data() {
    return {
      articles: __webpack_require__(30),
      colors: [['f44336', 'e91e63', '4caf50', 'cddc39', 'ffeb3b', 'ffc107', 'ff9800', 'ff5722'], ['9c27b0', '673ab7', '3f51b5', '2196f3', '03a9f4', '00bcd4', '009688', '8bc34a']],
      background: {
        first: '',
        seconde: ''
      }
    };
  },
  beforeMount: function beforeMount() {
    var colorOne = Math.floor(Math.random() * this.colors[0].length);
    var colorTwo = Math.floor(Math.random() * this.colors[1].length);

    this.background.first = '#' + this.colors[0][colorOne];
    this.background.seconde = '#' + this.colors[1][colorTwo];

    window.height = function () {
      return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    };

    window.visible = function (element, percentageViewTop) {
      var rect = element.getBoundingClientRect();
      var elTop = rect.top <= window.height() / 100 * percentageViewTop && rect.bottom >= window.height() / 100 * percentageViewTop;
      var elBot = rect.bottom <= window.height() && rect.bottom >= window.height() / 100 * (100 - percentageViewTop);

      return {
        top: rect.top < -75,
        lol: { elTop: elTop, elBot: elBot },
        bloc: elTop || elBot
      };
    };

    window.tilt = function (element) {
      var height = element.clientHeight;
      var max = 10 / (height / 250);

      __WEBPACK_IMPORTED_MODULE_4_vanilla_tilt___default.a.init(element, {
        max: max,
        speed: 300
      });
    };
  },

  computed: {
    bg: function bg() {
      return 'background: linear-gradient(45deg, ' + this.background.first + ', ' + this.background.seconde + ') fixed;background-size: 400% 400%';
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ahead',
  data: function data() {
    return {
      firstname: 'Steeve',
      lastname: 'Clément',
      job: 'Intégrateur / Développeur Front-End'
    };
  },

  computed: {
    fullname: function fullname() {
      return this.firstname + ' ' + this.lastname;
    }
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'categorie',
  props: ['item'],
  data: function data() {
    return {
      percentageViewTop: 80,
      visibleTop: false,
      visible: false
    };
  },
  mounted: function mounted() {
    var self = this;

    ['load', 'scroll'].forEach(function (event) {
      window.addEventListener(event, function () {
        self.visible = window.visible(self.$el, self.percentageViewTop).bloc;
      });
    });

    window.tilt(self.$el);
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navigation',
  data: function data() {
    return {
      items: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    var content = document.querySelectorAll('.content');

    content.forEach(function (element) {
      var item = {};
      item.id = element.getAttribute('id');
      item.icon = element.querySelector('h2 i').textContent;
      item.visible = false;

      document.addEventListener('scroll', function () {
        item.visible = window.visible(element).top;
      });

      _this.items.push(item);
    });
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'presentation',
  data: function data() {
    return {
      data: __webpack_require__(31),
      percentageViewTop: 80,
      visibleTop: false,
      visible: false
    };
  },

  computed: {
    phone: function phone() {
      return this.data.location.phone.match(/.{2}/g).join('.');
    }
  },
  mounted: function mounted() {
    var self = this;

    ['load', 'scroll'].forEach(function (event) {
      window.addEventListener(event, function () {
        self.visible = window.visible(self.$el, self.percentageViewTop).bloc;
      });
    });

    window.tilt(self.$el);
  }
});

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(25),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(15)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(28),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(14)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(27),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(13)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(26),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.bg),
    attrs: {
      "id": "app"
    }
  }, [_c('ahead'), _vm._v(" "), _c('navigation'), _vm._v(" "), _c('presentation'), _vm._v(" "), _vm._l((_vm.articles), function(article) {
    return [_c('categories', {
      attrs: {
        "item": article
      }
    })]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h1', [_vm._v(_vm._s(_vm.fullname))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.job))])])
},staticRenderFns: []}

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "content",
    class: {
      visible: _vm.visible
    },
    attrs: {
      "id": "intro"
    }
  }, [_c('h2', [_c('md-icon', [_vm._v(_vm._s(_vm.data.icon))]), _c('span', [_vm._v(_vm._s(_vm.data.title))])], 1), _vm._v(" "), _c('section', [_c('h3', [_vm._v(_vm._s(_vm.data.location.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.data.location.department) + ", " + _vm._s(_vm.data.location.region))])]), _vm._v(" "), _c('section', [_c('h3', [_vm._v(_vm._s(_vm.data.description.title))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.data.description.text)
    }
  })]), _vm._v(" "), _c('div', [_c('section', [_c('h3', [_vm._v(_vm._s(_vm.data.social.title))]), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    staticClass: "icon-github",
    attrs: {
      "href": "https://github.com/TokaLazy",
      "title": "Regardez mes projets GitHub",
      "target": "_blank"
    }
  }, [_vm._v("Github")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "icon-linkedin",
    attrs: {
      "href": "https://www.linkedin.com/in/steeve-clement-a8837b91/",
      "title": "Consultez mon profil LinkedIn",
      "target": "_blank"
    }
  }, [_vm._v("LinkedIn")])])])
}]}

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.items.length) ? _c('ul', {
    staticClass: "navigation"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', [_c('a', {
      directives: [{
        name: "scroll-to",
        rawName: "v-scroll-to",
        value: ('#' + item.id),
        expression: "'#'+item.id"
      }],
      class: {
        visible: item.visible
      },
      attrs: {
        "href": '#' + item.id
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
        }
      }
    }, [_c('md-icon', [_vm._v(_vm._s(item.icon))])], 1)])
  }), 0) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "content",
    class: [_vm.item.type, {
      visible: _vm.visible
    }],
    attrs: {
      "id": _vm.item.id
    }
  }, [_c('h2', [_c('md-icon', [_vm._v(_vm._s(_vm.item.icon))]), _c('span', [_vm._v(_vm._s(_vm.item.title))])], 1), _vm._v(" "), _c('div', _vm._l((_vm.item.content), function(content) {
    return _c('section', [_c('h3', [_vm._v(_vm._s(content.title))]), _vm._v(" "), (content.date_end) ? [(content.date_end) ? _c('em', [_vm._v(_vm._s(content.stint) + " " + _vm._s(content.date_start) + " - " + _vm._s(content.date_end))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(content.description))])] : _vm._e(), _vm._v(" "), (content.techno) ? _c('ul', _vm._l((content.techno), function(techno) {
      return _c('li', [_vm._v(" " + _vm._s(techno[0])), (techno[1]) ? _c('em', [_vm._v(" (" + _vm._s(techno[1]) + ")")]) : _vm._e()])
    }), 0) : _vm._e()], 2)
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, exports) {

module.exports = [{"id":"competence","title":"Compétences","icon":"code","icon2":"icon-code","type":"list","content":[{"title":"Front-End","icon":"important_devices","techno":[["HTML 5"],["CSS 3","Less, Sass"],["Javascript","ES5, ES6, jQuery, VueJS, React"]]},{"title":"Back-End","icon":"https","techno":[["PHP 5.5"],["MySQL"]]},{"title":"Outils","icon":"build","techno":[["Task Manager","npm, yarn, bower, webpack"],["Git","cli, sourcetree"],["IDE","VS Code, ST3, Atom"]]}]},{"id":"experience","title":"Expériences professionnelles","icon":"work","icon2":"icon-rocket","type":"section","content":[{"title":"Webedia","stint":"Intégrateur","date_start":"06/2017","date_end":"Aujourd'hui","description":""},{"title":"Cogit Studio","stint":"Développeur Front-End","date_start":"10/2015","date_end":"06/2017","description":"En charge de plusieurs sites","techno":[["TMA/TME du site Dan-on"],["Création de Landing-Page"],["Template d'email"]]},{"title":"Geeko-HC","stint":"Développeur Full-Stack","date_start":"06/2015","date_end":"08/2015","description":"Refonte complète du site pour améliorer la sécurité ainsi que pour l'utilisation de PHP en programmation orientée objet.","techno":[["Programmation PHP 5.5 POO"],["Base de données avec MySQL"],["Intégration HTML 5"],["Écriture d'un nouveau CSS avec Bourbon et Neat"],["Versioning du projet grâce à Git en ligne de commande"],["Animation mineur avec jQuery"]]},{"title":"Sowefund","stint":"Intégrateur / Développeur Front-End","date_start":"02/2015","date_end":"04/2015","description":"Chargé de la réduction du CSS et de la réécriture du HTML pour améliorer le référencement naturel grâce aux nouvelles balises.","techno":[["Grunt"],["Versioning du projet grâce à Git en ligne de commande"],["Utilisation des dernières balises HTML 5"],["Écriture d'un nouveau CSS avec Bourbon et Neat"]]},{"title":"Geeko-HC","stint":"Développeur Full-Stack","date_start":"01/2013","date_end":"04/2013","description":"Conception intégrale d'une plateforme sécurisée par des sessions pour l'enregistrement d'informations sur les points de vie des joueurs du jeu internet Heroes Chronicles.","techno":[["Programmation PHP 5.2 procédurale"],["Base de données avec MySQL"],["Intégration HTML 5"],["Stylisation du site avec CSS 3"]]},{"title":"S.O.S. Serrurerie","stint":"Responsable en référencement naturel","date_start":"10/2010","date_end":"02/2011","description":"Charger de la création de sites de serrurerie et de l'optimisation de la visibilité sur les différents moteurs de recherche.","technos":[]}]},{"id":"formation","title":"Formations","icon":"assignment","icon2":"icon-clipboard","type":"section","content":[{"title":"Formation Webmaster 3W Academy","date_start":"12/2013","date_end":"02/2014"}]}]

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {"icon":"tag_faces","title":"Présentation","location":{"title":"Localisation","region":"Ile-de-France","department":"Seine-et-Marne","city":"Chelles","email":"cl.steeve@gmail.com"},"description":{"title":"Description","text":"<p>Développeur web, je suis assoiffé de nouvelles connaissances en langages de programmation front-end.</p><p>Tout d'abord autodidacte pendant plusieurs années, j'ai suivi une formation afin d'approfondir mes connaissances et surtout d'en apprendre plus sur le JavaScript et tout ce qui l'entoure.</p><p>À moyen terme j'aimerais me spécialiser dans le JavaScript et toutes ses déclinaisons (NodeJS, jQuery, Vuejs, Angular, React, etc) sans pour autant fermer la porte à d'autres langages incontournables du web !</p>"},"social":{"title":"Réseaux sociaux","data":[{"id":"Github","link":"https://github.com/TokaLazy","title":"Regardez mes projets GitHub"},{"id":"LinkedIn","link":"https://www.linkedin.com/in/steeve-clement-a8837b91","title":"Consultez mon profil LinkedIn"}]}}

/***/ })
],[6]);


// WEBPACK FOOTER //
// static/js/app.cd53544b4d1851fd71a7.js